import { FC } from 'react';
import Head from 'next/head';

import ValuationHero320 from '../../assets/hero-320.jpg';
import ValuationHero600 from '../../assets/hero-600.jpg';
import ValuationHero800 from '../../assets/hero-800.jpg';

const SRC_SIZES: { maxWidth?: number; width: string }[] = [
    {
        maxWidth: 1279,
        width: '50vw',
    },
    // Above 1280px the image is half of the max width of the hero which on the
    // control is 1224px wide
    {
        width: '612px',
    },
];

const SRC_SET = [
    {
        width: 320,
        src: ValuationHero320,
    },
    {
        width: 600,
        src: ValuationHero600,
    },
    {
        width: 800,
        src: ValuationHero800,
    },
];

type HeroImageProps = JSX.IntrinsicElements['img'] & {
    minImageDisplayWidth?: number;
};

const HeroImage: FC<HeroImageProps> = ({
    minImageDisplayWidth = 1024,
    alt = 'Two homeowners discussing home valuations with an agent that they booked using Zoopla',
    ...props
}) => {
    const nonMobileMedia = `(min-width: ${minImageDisplayWidth}px)`;

    const sizesArray = SRC_SIZES.map(({ maxWidth, width }) =>
        maxWidth ? `(max-width: ${maxWidth / 16}em) ${width}` : width
    );

    const srcSetArray = SRC_SET.map(({ src, width }) => `${src} ${width}w`);

    return (
        <>
            <Head>
                <link
                    rel="preload"
                    as="image"
                    href=""
                    imageSrcSet={srcSetArray.join(', ')}
                    imageSizes={sizesArray.join(', ')}
                    media={nonMobileMedia}
                />
            </Head>
            <picture>
                {/**
                 * Omit srcSet for mobile sizes as we do not display the img,
                 * but only if the min width is larger than 0, otherwise it will
                 * display for everyone
                 */}
                {minImageDisplayWidth > 0 && (
                    <source
                        srcSet={''}
                        media={`(max-width: ${minImageDisplayWidth - 1}px)`}
                    />
                )}
                <source
                    sizes={sizesArray.join(', ')}
                    srcSet={srcSetArray.join(', ')}
                    media={nonMobileMedia}
                />
                {/**
                 * Omit src so that we do not fallback on mobile sizes
                 * */}
                <img alt={alt} {...props} />
            </picture>
        </>
    );
};

export default HeroImage;
